import { createFileRoute } from "@tanstack/react-router";
import { Download } from "lucide-react";
import { AdminEmptyTab } from "@/components/dashboard/AdminEmptyTab";

export const Route = createFileRoute("/dashboard/admin/revenue-monthly")({
  head: () => ({ meta: [{ title: "Monthly Revenue · Admin" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <AdminEmptyTab
      title="Monthly revenue"
      description="Monthly recurring revenue, growth, and churn."
      stats={[
        { label: "MRR" },
        { label: "New MRR" },
        { label: "Expansion MRR" },
        { label: "Churned MRR" },
      ]}
      body="Monthly revenue breakdown will appear here."
      primaryAction={{ label: "Export report", icon: Download }}
      columns={["Month", "MRR", "New", "Expansion", "Churn", "Net"]}
    />
  ),
});
